import { render, staticRenderFns } from "./sample-popover.vue?vue&type=template&id=59401f3c"
import script from "./sample-popover.vue?vue&type=script&lang=ts"
export * from "./sample-popover.vue?vue&type=script&lang=ts"
import style0 from "./sample-popover.vue?vue&type=style&index=0&id=59401f3c&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports